import { render, staticRenderFns } from "./FormContainer.vue?vue&type=template&id=22985626&scoped=true"
import script from "./FormContainer.vue?vue&type=script&lang=js"
export * from "./FormContainer.vue?vue&type=script&lang=js"
import style0 from "./FormContainer.vue?vue&type=style&index=0&id=22985626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22985626",
  null
  
)

export default component.exports